<template>
  <div>
    <div class="FeatureFlag r">
      <input
        type="checkbox"
        class="checkbox"
        :checked="enabled"
        disabled
        @change="handleChange"
      />
      <div class="FeatureFlag__Knobs"></div>
      <div class="FeatureFlag__Layer"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FeatureFlag',
  components: {},
  props: {
    enabled: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    handleChange(ev) {
      this.$emit('update:feature', ev.target.checked);
    },
  },
}
</script>

<style lang="scss" scoped>
.FeatureFlag__Knobs,
.FeatureFlag__Layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.FeatureFlag {
  position: relative;
  top: 50%;
  width: 74px;
  height: 36px;
  margin: -20px auto 0 auto;
  overflow: hidden;
  display: inline-block;
}

.FeatureFlag.r,
.FeatureFlag.r .FeatureFlag__Layer {
  border-radius: 100px;
}

.FeatureFlag.b2 {
  border-radius: 2px;
}

.checkbox {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  z-index: 3;
}

.FeatureFlag__Knobs {
  z-index: 2;
}

.FeatureFlag__Layer {
  width: 100%;
  background-color: #ebf7fc;
  transition: 0.3s ease all;
  z-index: 1;
  border: 2px solid #f4f4f4;
}

.FeatureFlag .FeatureFlag__Knobs:before {
  content: "YES";
  position: absolute;
  top: 4px;
  left: 4px;
  width: 27px;
  height: 27px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  padding: 9px 4px;
  background-color: #03a9f4;
  border-radius: 50%;
  transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;
}

.FeatureFlag .checkbox:checked + .FeatureFlag__Knobs:before {
  content: "NO";
  left: 42px;
  background-color: #f44336;
}

.FeatureFlag .checkbox:checked ~ .FeatureFlag__Layer {
  background-color: #fcebeb;
}

.FeatureFlag .FeatureFlag__Knobs,
.FeatureFlag .FeatureFlag__Knobs:before,
.FeatureFlag .FeatureFlag__Layer {
  transition: 0.3s ease all;
}
</style>
